// src/components/ManifestItemCard.jsx
import { useRef } from "react";
import { PaperDarkBG } from "../DesignKit";
import RoughBorder from "../LayoutKit/RoughBorder";

const ManifestItemCard = ({ id, title, text }) => {
  const cardRef = useRef();

  return (
    <div
      ref={cardRef}
      className="
        relative
        h-auto sm:h-48
        flex flex-col
        bg-gradient-to-br from-gray-100 via-white to-gray-100/25
       
        rounded-xl
        p-4 sm:p-6
        shadow-md
     
      font-mono
        max-w-full sm:max-w-4xl mx-auto space-y-2
      "
   
    >
      {/* ID */}
      <div className="text-xs sm:text-sm font-semibold text-gray-800 px-2">
        {id}
      </div>

      {/* Titel */}
      <PaperDarkBG className="rounded-lg overflow-hidden">
        <p className="
          text-xs sm:text-xs text-white
          leading-tight pt-3 pb-2 px-3 rounded-md line-clamp-2
        ">
          {title}
        </p>
      </PaperDarkBG>

      {/* Fließtext */}
      <p className="
        flex-grow text-xs sm:text-xs text-gray-700 leading-relaxed px-3
      ">
        {text}
      </p>

      {/* RoughBorder als Außenrahmen */}
      <RoughBorder
        parentRef={cardRef}
          radius={18}
          padding={2}
          color="#AC8E66" 
          strokeWidth={0.3}
          oughness={1.1}
          bowing={2}
   
      />
    </div>
  );
};

export default ManifestItemCard;
